"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Campaign = void 0;
const rule_1 = require("./rule");
const Model = __importStar(require("./index"));
const with_class_name_1 = require("./with-class-name");
const _ = __importStar(require("lodash"));
const campaign_batching_1 = require("./campaign-batching");
const extra_data_1 = require("./extra-data");
const message_template_data_1 = require("./message-template-data");
class Campaign extends with_class_name_1.WithClassName {
    constructor() {
        super(...arguments);
        this.id = '';
        this.name = '';
        this.isCampaignGrouper = false;
        this.tenant = '';
        this.tags = [];
        this.priority = 1;
        this.topics = [];
        this.groupCampaignId = '';
        this.contentMode = 'transactional';
        this.rule = new rule_1.Rule();
        this.startDate = new Date;
        this.endDate = new Date;
        this.isEnabled = false;
        this.hasDirectLink = false;
        this.linkType = 'noLink';
        this.isRecurrenceEnabled = false;
        this.recurrence = new campaign_batching_1.CampaignBatching();
        this.extraData = new extra_data_1.ExtraData();
        this.directLink = '';
        this.campaignFormName = '';
        this.promotionUrls = [];
        this.recipients = [];
        this.createdDate = new Date;
        this.directLinkWithoutShorten = '';
        this.trackConversionUntil = 14;
        this.currentCycle = '';
        this.currentCycleStartDate = new Date;
        this.trackConversion = true;
        this.templateData = new message_template_data_1.MessageTemplateData();
        this.pwaCampaign = false;
        this.schedule = false;
        this.scheduleTime = '';
        this.isRescheduled = false;
        this.isAutoSelect = false;
        this.businessUnit = '';
        this.successMetricData = "";
        this.links = [];
        this.dynamicAttachment = null;
    }
    get isBatch() {
        return this.rule && this.rule.isBatch;
    }
    get isEligibleForGroup() {
        return this.isBatch && this.isRecurrenceEnabled && !this.isCampaignGrouper;
    }
    get canHaveContent() {
        return !this.isCampaignGrouper && _.isEmpty(this.extraData.offers);
    }
    addRecipient(recipientType) {
        let RecipientType = _.get(Model, `${recipientType}`);
        let recipient = new RecipientType();
        let recipientIndex = _.findIndex(this.recipients, recipient);
        if (recipientIndex === -1) {
            this.recipients.push(recipient);
        }
    }
    removeRecipient(recipient) {
        _.remove(this.recipients, recipient);
    }
    hasPromoLink() {
        return this.linkType !== 'noLink';
    }
    syncLinkTypeFields() {
        switch (this.linkType) {
            case 'noLink':
                this.clearDirectLink();
                this.clearCampaignForm();
                this.clearAttachments();
                break;
            case 'attachment':
                this.clearDirectLink();
                this.clearCampaignForm();
                break;
            case 'campaignForm':
                this.clearDirectLink();
                this.clearAttachments();
                break;
            case 'directLink':
                this.hasDirectLink = true;
                this.clearCampaignForm();
                this.clearAttachments();
                break;
            case 'directLinkWithoutShorten':
                this.hasDirectLink = false;
                this.clearCampaignForm();
                this.clearAttachments();
                break;
            case 'verificationLink':
                this.clearDirectLink();
                this.clearAttachments();
                break;
            default:
        }
    }
    addPromoMaker(promotionImages) {
        if (this.hasPromoLink()) {
            _.each(this.recipients, (r) => {
                // r.addPromoMarker();
            });
        }
    }
    clearAttachments() {
        this.promotionUrls = [];
    }
    clearCampaignForm() {
        this.campaignFormName = undefined || '';
    }
    clearDirectLink() {
        this.directLink = undefined || '';
        this.hasDirectLink = false;
    }
}
exports.Campaign = Campaign;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/campaign.js
// module id = 1212
// module chunks = 0